export const styles = {
  container:
    'tw-flex tw-items-stretch tw-gap-1 tw-rounded-lg tw-border tw-border-solid tw-border-neutral-200 tw-p-3 tw-transition-colors hover:tw-bg-neutral-50',
  main:
    'tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-0.5 tw-cursor-pointer tw-rounded-md tw-text-left tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-primary-500',
  info: 'tw-flex tw-flex-col tw-gap-0.5',
  name: 'tw-text-sm tw-font-medium tw-text-neutral-800',
  email: 'tw-text-xs tw-text-neutral-500',
  role: 'tw-text-xs tw-text-primary-600 tw-font-medium',
  icon: 'tw-text-neutral-400',
  deleteButton: 'tw-text-danger-600',
};
